/** Public marketing landing page (logged-out root). Composed from the
 * section components in components/landing/, built from docs/LANDING_COPY.md. */
import { Nav } from '../components/landing/Nav.js';
import { Hero } from '../components/landing/Hero.js';
import { SocialProof } from '../components/landing/SocialProof.js';
import { Problem } from '../components/landing/Problem.js';
import { Features } from '../components/landing/Features.js';
import { Objections } from '../components/landing/Objections.js';
import { Pricing } from '../components/landing/Pricing.js';
import { Faq } from '../components/landing/Faq.js';
import { FinalCta } from '../components/landing/FinalCta.js';
import { Footer } from '../components/landing/Footer.js';

export function Landing() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Nav />
      <main>
        <Hero />
        <SocialProof />
        <Problem />
        <Features />
        <Objections />
        <Pricing />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
